import { Record, Union } from "../.fable/fable-library.3.1.4/Types.js";
import { Termin$reflection, Rahmenprogramm$0027$reflection, Programm$0027$reflection, Session$0027$reflection, Raum$0027$reflection, Manuskript$reflection, Beitrag$0027$reflection, Tag$0027$reflection } from "../Domain.fs.js";
import { record_type, tuple_type, class_type, option_type, list_type, bool_type, union_type, string_type } from "../.fable/fable-library.3.1.4/Reflection.js";
import { exists } from "../.fable/fable-library.3.1.4/List.js";
import { Msg$reflection as Msg$reflection_1 } from "./Api.fs.js";

export class Tab extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Tag", "Posters", "TabSession", "Rahmenprogramm", "EigenesProgramm"];
    }
}

export function Tab$reflection() {
    return union_type("TagungsProgramm.Types.Tab", [], Tab, () => [[["Item", Tag$0027$reflection()]], [], [["Item", string_type]], [], []]);
}

export class Route extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Home", "Beitrag", "Rahmenprogramm", "RahmenprogrammPunkt", "Session", "Programm"];
    }
}

export function Route$reflection() {
    return union_type("TagungsProgramm.Types.Route", [], Route, () => [[], [["Item", string_type]], [], [["Item", string_type]], [["Item", string_type]], [["Item", string_type]]]);
}

export class Subscription extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["Subscribed", "Unsubscribed", "PartialySubscribed"];
    }
}

export function Subscription$reflection() {
    return union_type("TagungsProgramm.Types.Subscription", [], Subscription, () => [[], [], []]);
}

export class Model extends Record {
    constructor(IstAngemeldet, AnmeldungAnfordern, EigenesProgramm, ProfileUrl, Tage, Ausgew$00E4hlt, Sprache, ZeitenInOrtszeit, Route, Beitr$00E4ge, Manuskripte, Session, Programm, Beitrag, Poster, TabSessions, Rahmenprogramm, Termine, Thema, RahmenprogrammPunkt) {
        super();
        this.IstAngemeldet = IstAngemeldet;
        this.AnmeldungAnfordern = AnmeldungAnfordern;
        this.EigenesProgramm = EigenesProgramm;
        this.ProfileUrl = ProfileUrl;
        this.Tage = Tage;
        this["Ausgewählt"] = Ausgew$00E4hlt;
        this.Sprache = Sprache;
        this.ZeitenInOrtszeit = ZeitenInOrtszeit;
        this.Route = Route;
        this["Beiträge"] = Beitr$00E4ge;
        this.Manuskripte = Manuskripte;
        this.Session = Session;
        this.Programm = Programm;
        this.Beitrag = Beitrag;
        this.Poster = Poster;
        this.TabSessions = TabSessions;
        this.Rahmenprogramm = Rahmenprogramm;
        this.Termine = Termine;
        this.Thema = Thema;
        this.RahmenprogrammPunkt = RahmenprogrammPunkt;
    }
}

export function Model$reflection() {
    return record_type("TagungsProgramm.Types.Model", [], Model, () => [["IstAngemeldet", bool_type], ["AnmeldungAnfordern", bool_type], ["EigenesProgramm", bool_type], ["ProfileUrl", string_type], ["Tage", list_type(Tag$0027$reflection())], ["Ausgewählt", option_type(Tab$reflection())], ["Sprache", string_type], ["ZeitenInOrtszeit", bool_type], ["Route", option_type(Route$reflection())], ["Beiträge", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [class_type("System.Guid"), list_type(Beitrag$0027$reflection())])], ["Manuskripte", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, Manuskript$reflection()])], ["Session", option_type(tuple_type(Raum$0027$reflection(), Session$0027$reflection()))], ["Programm", option_type(tuple_type(Raum$0027$reflection(), Programm$0027$reflection()))], ["Beitrag", option_type(Beitrag$0027$reflection())], ["Poster", list_type(tuple_type(string_type, list_type(Beitrag$0027$reflection())))], ["TabSessions", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, list_type(tuple_type(string_type, list_type(Beitrag$0027$reflection())))])], ["Rahmenprogramm", list_type(Rahmenprogramm$0027$reflection())], ["Termine", list_type(Termin$reflection())], ["Thema", option_type(tuple_type(string_type, list_type(Beitrag$0027$reflection())))], ["RahmenprogrammPunkt", option_type(Rahmenprogramm$0027$reflection())]]);
}

export function Model__IstSubscribed_2297AD2E(__, nummer) {
    let nummer_3, nummer_1;
    const matchValue = [nummer, __.Termine];
    let pattern_matching_result;
    if (matchValue[0] != null) {
        if (nummer_1 = matchValue[0], exists((t_1) => (t_1.Id === nummer_1), matchValue[1])) {
            pattern_matching_result = 0;
        }
        else {
            pattern_matching_result = 1;
        }
    }
    else {
        pattern_matching_result = 1;
    }
    switch (pattern_matching_result) {
        case 0: {
            return new Subscription(0);
        }
        case 1: {
            let pattern_matching_result_1;
            if (matchValue[0] != null) {
                if (nummer_3 = matchValue[0], exists((t_4) => (t_4.SessionId === nummer_3), matchValue[1])) {
                    pattern_matching_result_1 = 0;
                }
                else {
                    pattern_matching_result_1 = 1;
                }
            }
            else {
                pattern_matching_result_1 = 1;
            }
            switch (pattern_matching_result_1) {
                case 0: {
                    return new Subscription(2);
                }
                case 1: {
                    return new Subscription(1);
                }
            }
        }
    }
}

export class Msg extends Union {
    constructor(tag, ...fields) {
        super();
        this.tag = (tag | 0);
        this.fields = fields;
    }
    cases() {
        return ["ApiMsg", "AnmeldungAnfordernSchliessen", "Wechseln", "ThemaZeigen", "ThemaSchliessen", "SessionZeigen", "SessionSchliessen", "ToggleSubscribtion", "ProgrammZeigen", "ProgrammSchliessen", "BeitragZeigen", "BeitragSchliessen", "RahmenprogrammZeigen", "RahmenprogrammSchliessen", "BeiträgeNachladen"];
    }
}

export function Msg$reflection() {
    return union_type("TagungsProgramm.Types.Msg", [], Msg, () => [[["Item", Msg$reflection_1()]], [], [["Item", Tab$reflection()]], [["Item", tuple_type(string_type, list_type(Beitrag$0027$reflection()))]], [], [["Item1", Raum$0027$reflection()], ["Item2", Session$0027$reflection()]], [], [], [["Item1", Raum$0027$reflection()], ["Item2", Programm$0027$reflection()]], [], [["Item", Beitrag$0027$reflection()]], [], [["Item", Rahmenprogramm$0027$reflection()]], [], [["Item", Session$0027$reflection()]]]);
}

